<template >
  <div class="form-group lm-super-power-select-v2" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      v-if="label"
      :title="titleComputed"
      :for="idComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >
      {{label}} <small v-if="required">*</small>
    </label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <p v-if="dataSelectedDeleted">
      <span>
        La opción seleccionada <strong>{{ this.value.name }}</strong> se encuentra eliminada. <b-link @click="dataSelectedDeleted = false">Cambiar.</b-link>
      </span>
    </p>
    <div
      :class="{ 'col-sm-10': isOnModeLabelOnLeft }"
      @keyup.enter="enter"
      >
      <v-selectpage
        v-if="!dataSelectedDeleted"
        tabindex="0"
        class="text-truncate"
        ref="vSelectpage"
        :key-field="keyField"
        :disabled="disabled || isLoading"
        :class="{'selectpage-error': v.$error}"
        :data="optionsData"
        :pageSize="pageSize"
        :multiple="multiple"
        :language="language"
        :title="title"
        :tb-columns="tbColumns"
        :placeholder="isLoading ? 'Loading...' : placeholder"
        v-model="optionSelected"
        @values="valuesHandler($event)"
        />
      <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import { SelectPage } from 'v-selectpage'
import lmInputMixin from '@/mixins/lmInputMixin.js'
import commonsApi from '@/api/commons'
export default {
  data () {
    return {
      optionSelected: null,
      optionsData: [],
      isLoading: false,
      dataSelectedDeleted: false
    }
  },
  mixins: [lmInputMixin],
  components: {
    'v-selectpage': SelectPage
  },
  props: {
    defaultValue: {
      type: [Object, Array, String],
      default: () => ({})
    },
    keyField: {
      type: String,
      default: 'id'
    },
    tbColumns: {
      type: Array,
      default: () => []
    },
    language: {
      type: String,
      default: 'es'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    options: {
      type: [String, Array],
      default: ''
    },
    urlPathFromGetOptions: {
      type: String,
      default: ''
    },
    itemsOrder: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    checkIfDataSelectedWasDeleted (val) {
      if (typeof this.value === 'object' && !Array.isArray(this.value) && this.value?.id) {
        if (!val.some(o => o.id === this.value.id) && this.multiple === false) {
          this.dataSelectedDeleted = true
        }
      }
    },
    /*
      Funcion que ordena los resultados emitidos por vSelectPage
      Espera recibir un Array de IDs en el orden deseado
    */
    orderItems (event) {
      // Si no hay un orden especificado
      if (!this.itemsOrder.length) {
        return event
      }
      const originalOrder = this.itemsOrder
      const orderedItems = []
      originalOrder.forEach(el => {
        const item = event.find(e => String(e.id) === String(el))
        if (item !== undefined) {
          orderedItems.push(item)
        }
      })
      // Si agrego nuevos elementos se añaden al final
      event.forEach(el => {
        if (!originalOrder.includes(el.id)) {
          orderedItems.push(el)
        }
      })
      return orderedItems
    },
    valuesHandler (event) {
      this.dataSelected = event
      const result = this.orderItems(event)
      let optionsSelected = ''
      optionsSelected = this.multiple ? result : result[0]
      // Si borro el contenido de superpower desde la "x" debo enviar [] para que se elimine su contenido
      if (Array.isArray(result) && !result.length && !this.multiple) {
        optionsSelected = []
      }
      this.$emit('input', optionsSelected)
    },
    enter () {
      this.$refs.vSelectpage.$refs.drop.visible()
      this.$on('values', function () {
        setTimeout(() => {
          this.$refs.vSelectpage.$el.focus()
        }, 1000)
      })
    },
    remove () {
      this.$refs.vSelectpage.remove()
    },
    hide () {
      setTimeout(() => {
        if (this.$refs.vSelectpage.$refs.drop.show) {
          this.$refs.vSelectpage.$refs.drop.visible()
        }
      }, 10)
    },
    async initialOptionSelected (value = this.value) {
      /*
        Debe retornar siempre un string con el ID del valor seteado
        o IDs separados por coma (en caso de ser multiple)
      */
      // if (this.defaultValue?.id) {
      //   value = this.defaultValue
      // }
      // if (Array.isArray(value) && value.length) {
      //   this.optionSelected = value.map(option => option.id).join(',')
      // }
      // if (value !== null && value !== undefined && value.constructor.name === 'Object') {
      //   this.optionSelected = value?.id?.toString()
      // }
      // if (typeof value === 'string' && this.options) {
      //   let option
      //   // En el SuperPowerBuilder no se mostraba la opción por defecto (en edit mode) del origen de datos
      //   if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_CODIFICATORS === 'yes') {
      //     option = this.options.find(e => e.path === value)
      //   } else {
      //     option = this.options.find(e => e.name === value)
      //   }
      //   this.optionSelected = option?.id?.toString()
      // }
    },
    defineOptionsSelected (opts) {
      // Si tengo un defaultValue
      if (typeof this.defaultValue === 'object' && Object.keys(this.defaultValue).length) {
        opts = this.defaultValue
      }
      // Si tengo un defaultValue y es un array (multiple)
      if (Array.isArray(this.defaultValue) && this.defaultValue.length && this.multiple) {
        opts = this.defaultValue
      }
      // Si es un array de objetos
      if (Array.isArray(opts) && opts.length) {
        this.optionSelected = opts.map(o => o.id).join(',')
      }
      // Si es un objeto (single mode)
      if (typeof opts === 'object' && !Array.isArray(opts) && Object.keys(opts).length) {
        this.optionSelected = String(opts?.id)
      }
      // Si es un path, se usa en el origen de datos del formbuilderUi
      if (typeof opts === 'string' && this.optionsData.length) {
        let option = null
        if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_CODIFICATORS === 'yes') {
          option = this.optionsData.find(o => o.path === opts)
        } else {
          option = this.optionsData.find(o => o.name === opts)
        }
        if (option) {
          this.optionSelected = option?.id
        } else {
          // Esta linea contempla el poder recibir directamente el ID
          // o un string de IDs separados por "," (resultado final esperado)
          this.optionSelected = opts
        }
      }
    },
    async getOptionsFromPath (url = this.urlPathFromGetOptions) {
      try {
        this.isLoading = true
        if (url) {
          const optionsFromPath = await commonsApi.axiosGetWrapper(url)
          return optionsFromPath?.data?.items || []
        } else {
          return []
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async setOptions () {
      if (this.urlPathFromGetOptions) {
        this.optionsData = await this.getOptionsFromPath()
      } else {
        this.optionsData = this.options
      }
    }
  },
  watch: {
    urlPathFromGetOptions () {
      this.setOptions()
    },
    options () {
      /*
        Fix: Arreglo bug en formbuilderUi, al agregar un componente se borra el
        origen de datos (opciones) del super power.
        Si hay "urlPathFromGetOptions" siempre la uso para obtener las opciones
      */
      if (this.urlPathFromGetOptions && !this.options.length) {
        this.setOptions()
      } else {
        this.optionsData = this.options
      }
    },
    optionsData (val) {
      this.checkIfDataSelectedWasDeleted(val)
    },
    defaultValue (newVal, oldVal) {
      /*
        defaultValue puede ser un string, array u objecto.
      */
      this.defineOptionsSelected(newVal)
      // Chequeo que sea un objeto y no un array. typeof array = [object array]
      // if (typeof newVal === 'object' && !Array.isArray(newVal)) {
      //   // Chequeo que el objeto tenga un id
      //   if (newVal?.id !== undefined) {
      //     this.initialOptionSelected(newVal)
      //   } else {
      //     this.initialOptionSelected(oldVal)
      //   }
      // } else if (typeof newVal === 'string') {
      //   // Se envia el ID como string en los formbuilderUI
      //   this.initialOptionSelected(newVal)
      // } else {
      //   // Se recibe un Array
      //   this.initialOptionSelected(newVal)
      // }
    },
    // Observo los valores que se envian por v-model
    value (newVal, oldVal) {
      if (newVal) {
        this.defineOptionsSelected(newVal)
        // this.initialOptionSelected(newVal)
      } else {
        // this.initialOptionSelected(oldVal)
      }
    }
  },
  async created () {
    await this.setOptions()
    // this.initialOptionSelected()
    this.defineOptionsSelected(this.value)
  }
}
</script>
<style>
.selectpage-error .sp-input-container .sp-inputs,
.selectpage-error .sp-input-container .sp-input {
  border: 1px solid red !important;
}

.sp-base {
  min-height: 38px !important;
}

.sp-input span {
  display: block !important;
  overflow: hidden;
  padding-right: 35px !important;
  text-overflow: ellipsis;
}
</style>
